<template>
  <v-dialog v-model="active" width="480" persistent>
    <v-card color="primary" class="rounded-sm">
      <v-card-title class="ui-module-titlebar font-weight-bold">
        Cambiar estatus de equipo
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text v-if="equipo">
        <v-select
          class="ui-form-field"
          v-model="equipo.fk_idCatEstatus"
          label="Estatus"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          item-color="secondary"
          item-value="id"
          item-text="title"
          :items="estatusEquipamiento"
        ></v-select>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <TextButton
          class="ui-module-btn-solid"
          rounded
          color="secondary"
          :disabled="loading"
          :loading="loading"
          @click="triggerUpdateEstatusEquipo()"
          >Guardar cambios</TextButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  props: {
    active: {
      type: Boolean,
    },

    equipo: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters('estatusEquipamiento', {
      estatusEquipamiento: 'getEstatusEquipamiento',
    }),
  },

  methods: {
    ...mapActions('equipo', ['fetchEquipo', 'updateEstatusEquipo']),

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    async triggerUpdateEstatusEquipo() {
      this.loading = true
      await this.updateEstatusEquipo({
        idEquipamiento: this.equipo.idEquipamiento,
        fk_idEstatus: this.equipo.fk_idCatEstatus,
      })

      await this.fetchEquipo()
      this.closeDialog()
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #ffbe76 !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  min-width: 168px;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #1f1305 !important;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.25) !important;
}
</style>
